<template>
  <div class="legal-text-picker">
    <form class="uk-search uk-search-default uk-margin-bottom"
          @submit.prevent="confirmSelection">
      <span uk-search-icon></span>
      <input ref="primaryInput"
             v-model="search"
             class="uk-search-input"
             type="search"
             :placeholder="placeholder">
    </form>
    <div class="uk-grid-small" uk-grid>
      <div class="uk-width-1-2">
        <div class="legal-texts uk-height-medium"
             @keyup.enter="confirmSelection"
             @keyup.up="selectPreviousLegalText"
             @keyup.down="selectNextLegalText">
          <ul class="uk-tab-right" v-if="legalTexts.length" uk-tab>
            <li v-for="(legalText, index) in legalTexts" :class="{'uk-active': selectedIndex === index}">
              <a href="#" @click="selectLegalText(index)">
                {{ legalText.name }}
              </a>
            </li>
          </ul>
          <div v-else>
            {{$t('noResults')}}
          </div>
        </div>
      </div>
      <div class="uk-width-1-2 uk-grid-item-match">
        <div class="uk-panel uk-panel-scrollable uk-background-muted
                    uk-padding-small uk-height-medium">
          <div v-if="selected" v-html="selected.body"/>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import legalTextsQuery from '@/api/queries/legal-texts.graphql';
import ResourceCombobox from '@/mixins/ResourceCombobox';

export default {
  name: 'legal-text-picker',
  mixins: [
    ResourceCombobox({
      searchQuery: legalTextsQuery,
      unfilteredSort: { field: 'UPDATED_AT', direction: 'DESC' },
    }),
  ],
  data() {
    return {
      selectedIndex: 0,
    };
  },
  computed: {
    legalTexts() {
      return this.options;
    },
    selected() {
      return this.legalTexts[this.selectedIndex];
    },
  },
  methods: {
    confirmSelection() {
      this.$emit('selectionConfirmed', this.internalValue);
    },
    selectLegalText(index) {
      if (this.legalTexts.length === 0) return;
      const legal = this.legalTexts[index];
      this.selectedIndex = index;
      this.internalValue = [legal];
      this.clearErrors();
      this.$emit('input', this.internalValue);
      this.$emit('change', this.internalValue);
    },
    selectNextLegalText() {
      if (this.selectedIndex === null || !this.legalTexts) return;
      if (this.legalTexts.length === 0) return;
      if (this.selectedIndex === (this.legalTexts.length - 1)) return;
      this.selectLegalText(this.selectedIndex + 1);
    },
    selectPreviousLegalText() {
      if (!this.selectedIndex || !this.legalTexts) return;
      if (this.legalTexts.length === 0) return;
      if (this.selectedIndex === 0) return;
      this.selectLegalText(this.selectedIndex - 1);
    },
    onResult() {
      this.selectLegalText(0);
    },
  },
  props: {
    value: {
      type: Array,
      default: () => [],
    },
  },
  i18n: {
    messages: {
      de: {
        noResults: 'Keine Rechtstexte gefunden',
      },
    },
  },
};
</script>

<style lang="scss" scoped>
.legal-texts {
  overflow-y: scroll;
  overflow-x: hidden;
}
.uk-search {
  width: 100%;
}
</style>



// WEBPACK FOOTER //
// LegalTextPicker.vue?0742ef98